export default (name: string) => {
  const isOpen = useState(`${name}-slide-in`, () => false)
  const toggle = (open?: boolean) => {
    isOpen.value = typeof open !== 'undefined' ? open : !isOpen.value
  }

  return { isOpen, toggle }
}
